import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { Prescription } from '@/types/medication';
import { QueryParams } from '@/types/query';

import { createRepository } from './GenericRepository';

interface MedicationParams extends QueryParams {
  person_id: string;
  show_inactive: 'true' | 'false';
}

const basePath = '/api/prescriptions';

export const medicationRepository = createRepository<Prescription, Prescription>(basePath);

const MedicationRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async list(params: MedicationParams) {
      const filteredParams = { ...params };
      if (filteredParams.show_inactive === undefined) {
        filteredParams.show_inactive = 'false';
      }
      return medicationRepository.listNoPagination({ host, params: filteredParams });
    }
  };
};

export default MedicationRepository;
export type { MedicationParams };
